<template>
  <div class="pagination mt-5">
    <div class="flex items-center justify-between border-gray-200 px-4 py-3 sm:px-6">
      <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p class="text-sm text-white">
            Showing
            <span class="font-medium">{{ startItem }}</span>
            to
            <span class="font-medium">{{ endItem }}</span>
            of
            <span class="font-medium">{{ totalItems }}</span>
            results
          </p>
        </div>
        <div>
          <nav class="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
            <button id="previous-page" @click="changePage(previousPageLink)" class="relative cursor-pointer inline-flex items-center rounded-l-md px-2 py-2 ring-1 ring-inset ring-gray-300 hover:bg-white/50 focus:z-20 focus:outline-offset-0" :disabled="!previousPageLink">
              <ChevronLeftIcon class="h-4 w-4" aria-hidden="true" />
              <span class="text-sm">Previous</span>
            </button>
            <template v-for="page in displayedPages" :key="page">
              <span v-if="page === '...'" class="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-white ring-1 ring-inset ring-gray-300 focus:outline-offset-0">...</span>
              <button v-else :id="'page-'+page" @click="changePage(page)" :class="{'bg-primary-color-2 text-white': page == currentPage}" class="relative inline-flex items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-white/50 focus:z-20 focus:outline-offset-0">
                {{ page }}
              </button>
            </template>
            <button id="next-page" @click="changePage(nextPageLink)" class="relative cursor-pointer inline-flex items-center rounded-r-md px-2 py-2 ring-1 ring-inset ring-gray-300 hover:bg-white/50 focus:z-20 focus:outline-offset-0" :disabled="!nextPageLink">
              <span class="text-sm">Next</span>
              <ChevronRightIcon class="h-4 w-4" aria-hidden="true" />
            </button>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/24/solid';

export default {
  name: "Pagination",
  components: {
    ChevronLeftIcon, ChevronRightIcon
  },
  props: {
    totalItems: Number,
    perPage: Number,
    currentPage: Number,
    previousPageLink: String,
    nextPageLink: String,
    searchQuery: String
  },
  computed: {
    startItem() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    endItem() {
      return Math.min(this.startItem + this.perPage - 1, this.totalItems);
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.perPage);
    },
    displayedPages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= 5) {
        // Show all pages if total is 5 or less
        for (let i = 1; i <= total; i++) pages.push(i);
      } else {
        if (current > 3) pages.push(1, '...');
        if (current === 1) {
          pages.push(1, 2, 3, '...');
        } else if (current === total) {
          pages.push('...', total - 2, total - 1, total);
        } else {
          pages.push(current - 1, current, current + 1);
        }
        if (current < total - 2) pages.push('...', total);
      }
      return pages;
    }
  },
  methods: {
    changePage(page) {
      if (typeof page === 'string') {
        const params = new URLSearchParams(page);
        const cleanPage = params.get('page');
        const cleanLimit = params.get('limit');
        this.$emit('page-changed', cleanPage || 1, cleanLimit || 10, this.searchQuery); 
      } else {
        this.$emit('page-changed', page, this.perPage, this.searchQuery);
      }
    }
  }
}
</script>

<style scoped>
.main-menu-container {
  display: flex;
  justify-content: center;
}
.main-menu {
  border-radius: 3rem;
  background-color: rgba(243, 128, 157, 0.7);
}
</style>